import { useEffect, useState } from "react";
import AppLayout from "@/components/AppLayout";
import { ClientSidebar } from "@/components/sidebars";
import { useAuth } from "@/lib/auth";
import { apiClient, formatApiError } from "@/lib/api";
import { trackEvent } from "@/lib/analytics";
import { toast } from "sonner";

const PLANES = [
  { id: "basico",   nombre: "Plan Básico",   precio: "4.99", regular: "8.00", max: 1, features: ["1 grúa al año","Servicio médico telefónico","Soporte por chat"] },
  { id: "estandar", nombre: "Plan Estándar", precio: "9.99", regular: "20.00", max: 4, featured: true, features: ["Incluye hasta 4 personas","3 grúas al año","Servicio médico 24/7","Ambulancia 1/año","Servicio legal"] },
];

export default function MiPlan() {
  const { user, refresh } = useAuth();
  const [loadingPlan, setLoadingPlan] = useState(null);

  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, []);

  const elegir = async (plan) => {
    if (!user?.beneficiarios?.length) {
      toast.error("Primero agrega al menos un beneficiario.");
      return;
    }
    setLoadingPlan(plan.id);
    try {
      const { data } = await apiClient.post("/checkout/session", { plan_id: plan.id, origin_url: window.location.origin });
      trackEvent("begin_checkout", {
        currency: "USD",
        value: parseFloat(plan.precio),
        items: [{ item_id: plan.id, item_name: plan.nombre, price: parseFloat(plan.precio), quantity: 1 }],
      });
      window.location.href = data.url;
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
      setLoadingPlan(null);
    }
  };

  return (
    <AppLayout sidebar={ClientSidebar}>
      <header className="app-header"><h1>Mi Plan</h1>
        <p className="text-muted">Estado actual: <strong>{user?.membership_status === "active" ? `Activa (${user?.plan})` : "Pendiente"}</strong></p>
      </header>
      <div className="planes-grid">
        {PLANES.map((p) => (
          <div key={p.id} className={`plan-card ${p.featured ? "featured" : ""}`} data-testid={`plan-${p.id}`}>
            {p.featured && <div className="plan-badge">MÁS POPULAR</div>}
            <div className="plan-header"><h3>{p.nombre}</h3></div>
            <div style={{ textAlign: "center", marginTop: 8 }}>
              <span style={{ display: "inline-block", background: "#E8F5D9", color: "#5BA628", padding: "4px 10px", borderRadius: 999, fontSize: 11, fontWeight: 700 }}>PROMO ANUAL</span>
              <div style={{ color: "#E84C5E", textDecoration: "line-through", fontWeight: 600, fontSize: 16, marginTop: 4 }}>USD ${p.regular}/mes</div>
            </div>
            <div className="plan-price"><span className="currency">USD $</span><span className="amount">{p.precio}</span><span className="period">/mes</span></div>
            <ul className="plan-features">{p.features.map((f, i) => <li key={i}><i className="fas fa-check" />{f}</li>)}</ul>
            <button onClick={() => elegir(p)} disabled={loadingPlan === p.id} className="btn btn-primary plan-btn" data-testid={`plan-elegir-${p.id}`}>
              {loadingPlan === p.id ? "Procesando..." : user?.plan === p.id && user?.membership_status === "active" ? "Plan actual" : "Elegir plan"}
            </button>
          </div>
        ))}
      </div>
    </AppLayout>
  );
}
